module.exports = "/_next/static/images/faq-b9e7cc55ba31e0751250c9879ce922ba.png";